import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const homeFor = (role) => {
  switch (role) {
    case "admin": return "/admin";
    case "client_lead": return "/admin";
    case "participant": return "/participant";
    case "manager":
    case "channel_partner": return "/rater";
    default: return "/login";
  }
};

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-sm text-[#878787] font-medium">Loading…</div>
    </div>
  );
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}

export { homeFor };
